import { TitleTypography } from '@design-system/components';
import { FC } from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { CustomerReviewProps, ICustomerReview, ICustomerReviewHeader } from './types';
import StyledContainer from '@design-system/styled/Container';
import ReviewSlider from './ReviewSlider';

const StyledWrapper = styled.section`
  width: 100%;
  background: ${(props) => props.theme.color.primarySubtle};
  ${(props) => props.theme.typo.familyGoogle.regular};
  color: ${(props) => props.theme.color.onSurface};
  padding-top: 46px;
  padding-bottom: 40px;

  .header {
    display: flex;
    flex-direction: column;
    text-align: center;

    .title {
      ${(props) => props.theme.typo.familyGoogle.medium}
      font-size: 22px;
      line-height: 32px;
      margin-bottom: 12px;
    }

    .desc {
      ${(props) => props.theme.typo.familyGoogle.regular}
      font-size: 12px;
      line-height: 20px;
      margin-bottom: 0;
    }
  }

  @media screen and (min-width: ${(props) => props.theme.metrics.breakpoints.md}) {
    padding-top: 60px;
    padding-bottom: 60px;

    .header {
      .title {
        font-size: 33px;
        margin-bottom: 20px;
      }

      .desc {
        font-size: 16px;
      }
    }
  }
`;

const CustomerReview: FC<CustomerReviewProps> = ({ content }) => {
  const { header, customerReviews } = content;

  return (
    <StyledWrapper role="region" aria-label="Customer Reviews">
      <StyledContainer>
        <div className="header">
          <TitleTypography className="title" level={2}>
            <Trans
              i18nKey={header.title}
              defaults={header.title}
              components={{
                span: <span />,
                strong: <strong />,
                specificFont: <span style={{ fontFamily: 'Poppins' }} />,
              }}
            />
          </TitleTypography>
          <p className="desc">
            <Trans i18nKey={header.description} defaults={header.description} />
          </p>
        </div>
      </StyledContainer>
      <div aria-label="Customer testimonials">
        <ReviewSlider reviews={customerReviews} />
      </div>
    </StyledWrapper>
  );
};

export default CustomerReview;
